import { useAppDispatch } from "@/stores";
import { setAuthenticationToken } from "@/stores/authSlice";
import { Box, CircularProgress, Container } from "@mui/material";

import Typography from "@mui/material/Typography";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

export default function KiokCode() {
  const isLoading = true;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(setAuthenticationToken(process.env.REACT_APP_API_SECRETE!));
      navigate("/", { replace: true });
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [navigate, dispatch]);

  const Loading = useMemo(() => {
    if (isLoading) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="h4">Verification...</Typography>
          <CircularProgress color="primary" />
        </Box>
      );
    }
    return null;
  }, [isLoading]);

  return (
    <Container maxWidth={false} sx={{ flex: 1 }}>
      {Loading}
    </Container>
  );
}
